// extracted by mini-css-extract-plugin
module.exports = {"color1":"#000","color2":"#fd9a1c","color3":"#FDF6F0","color4":"#76323F","color5":"#444","color6":"red","color7":"#e74c3c","color8":"#09652e","color9":"#fd9a1c","color10":"#0984e3"};